import { useContext } from 'react';
import { useWizard } from './context';
import { map } from 'ramda';

export const useStep = (step:number) => {
  const { state:{steps} } = useWizard();
  return steps[step];
}

export const useCurrentStep = () => {
  const { state: {step, initialSteps} } = useWizard();
  return { state: step, initial: initialSteps[step.index] };
}

export const useProgressIndicator = () => {
  const { state } = useWizard();
  const { steps, stepIndex, previousBtn, nextBtn, cancelBtn } = state;
  return {
    steps: map((x) => x.titleShort, steps),
    stepIndex,
    previousBtn,
    nextBtn,
    cancelBtn,
  }
};
